import React from "react";
import "./BookingStep1.scss";
import ServicesDisplay from "../../../components/ServicesDisplay/ServicesDisplay";

const BookingStep1 = (props) => {
  return (
    <div
      className="BookingStep1"
      ref={props.refr}
      onScroll={props.handleScroll}
    >
      <ServicesDisplay
        onChoose={(name, duration, price, id) => {
          props.nextStep();
          props.chooseService(name, duration, price, id);
          document.querySelector(".BookingHeader").className = "BookingHeader";
        }}
      />
    </div>
  );
};

export default BookingStep1;
